import * as Yup from "yup";
import { FormControl } from "_components/Forms/FormControl";
import { FormModal } from "_components/Forms/FormModal";
import { WasteBdoSelect } from "./WasteBdoSelect";
import { useFieldArray } from "react-hook-form";
import { HorizontalView } from "../Abstractions/HorizontalView";
import { DomainButton } from "../Abstractions/DomainButton";

export function WasteForm({ onSubmit, defaultValues, isUpdate }) {
  const validationSchema = Yup.object().shape({
    internalName: Yup.string()
      .required("Nazwa własna jest wymagana")
      .max(50, "Nazwa formalna nie może mieć więcej niż 50 znaków"),
    wasteBdo: Yup.object()
      .required()
      .typeError("Towar BDO jest wymagany")
      .shape({
        description: Yup.string()
          .required("Nazwa formalna jest wymagana")
          .max(400, "Kod odpadu nie może mieć więcej niż 50 znaków"),
      }),
  });

  const formControls = (
    <>
      <FormControl label="Nazwa wewnętrzna" name="internalName" autoFocus />
      <WasteBdoSelect name="wasteBdo" />
      <FormControl
        label="Nazwa formalna"
        name="wasteBdo.description"
        readonly
      />
      <FormControl label="Kod odpadu" name="wasteBdo.code" readonly />
      <FormControl label="Ref. BDO" name="wasteBdo.id" readonly />
      <WasteKindForm/>
    </>
  );

  const buttonText = isUpdate ? "Edytuj towar" : "Dodaj towar";
  const successMessage = isUpdate ? "Zaktualizowano towar" : "Dodano towar";
  const title = buttonText;

  const onSubmitForm = (data) => {
    const payload = {
      id: data.wasteId,
      wasteCodeBdoId: data.wasteBdo?.id,
      internalName: data.internalName,
      externalName: data.wasteBdo?.description,
      wasteCode: data.wasteBdo?.code,
      kinds: data.kinds
    };
    return onSubmit(payload);
  };

  return (
    <>
      <FormModal
        formControls={formControls}
        validationSchema={validationSchema}
        onSubmit={onSubmitForm}
        buttonText={buttonText}
        successMessage={successMessage}
        title={title}
        defaultValues={defaultValues}
        sizeModal="lg"
        btnSize="small"
      />
    </>
  );
}

const WasteKindForm = () => {
  const GetWasteKindFieldName = (fieldName, kindIndex) => `kinds[${kindIndex}].${fieldName}`;
  const { fields, append, remove } = useFieldArray({ name: "kinds" });
  const addItem = () => {
    append({ name: "" });
  };

  return <>
    <div className="mb-2">
      <b>Gatunki towaru</b>
      {fields?.map((wasteKind, kindIndex) => (
        <HorizontalView key={wasteKind.wasteKindId ?? wasteKind.id}>
          <FormControl name={GetWasteKindFieldName("name", kindIndex)} label="Nazwa"/>
          <DomainButton className="mt-2" size="small" onClick={() => remove(kindIndex)}>Usuń</DomainButton>
        </HorizontalView>
      ))}
      {fields?.length === 0 && <p>Brak gatunków</p>}
      <DomainButton size="small" onClick={addItem}>Nowy gatunek</DomainButton>
    </div>
  </>
}
